import { InputHTMLAttributes, forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

/**
 * IXVerify labeled input — the input itself follows the shared `fieldCls`
 * recipe (src/ui/styles.ts), with an error variant swapping the border/ring
 * to red. Prop API unchanged.
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={`
            w-full px-2.5 py-1.5 rounded-lg border bg-white text-sm text-gray-900 placeholder-gray-400
            focus:outline-none focus:ring-2 transition-colors duration-150
            disabled:cursor-not-allowed disabled:bg-gray-100 dark:disabled:bg-gray-800
            dark:bg-gray-700 dark:text-gray-100 dark:placeholder-gray-400
            ${error
              ? 'border-red-500 focus:border-red-500 focus:ring-red-500 dark:border-red-500'
              : 'border-gray-300 focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600'}
            ${className}
          `}
          {...props}
        />
        {error && (
          <p className="mt-1 text-sm text-red-600 dark:text-red-400">{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
